module.exports = __webpack_public_path__ + "static/media/Room1.e36b27a9.jpg";